(function () {
  const DESKTOP_MIN = 1041;
  const GAP = 12;

  function readVisibleHeaderBottom() {
    const stickyMenu = document.querySelector('.block_navigation_menu--sticky');
    if (stickyMenu instanceof HTMLElement) {
      const rect = stickyMenu.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0) {
        return Math.round(rect.bottom);
      }
    }

    const headerGroup = document.getElementById('header-group');
    if (!(headerGroup instanceof HTMLElement)) return 0;

    const rect = headerGroup.getBoundingClientRect();
    if (rect.bottom <= 0) return 0;
    return Math.round(rect.bottom);
  }

  function syncPdpStickyTop() {
    const root = document.querySelector('.product-information');
    if (!(root instanceof HTMLElement) || window.innerWidth < DESKTOP_MIN) return;

    const headerBottom = readVisibleHeaderBottom();
    const nextTop = headerBottom > 0 ? headerBottom + GAP : GAP;
    const current = parseFloat(getComputedStyle(root).getPropertyValue('--pdp-sticky-top')) || 0;

    if (Math.abs(current - nextTop) > 0.5) {
      root.style.setProperty('--pdp-sticky-top', `${nextTop}px`);
    }
  }

  let rafId = 0;
  function queueSync() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      syncPdpStickyTop();
    });
  }

  document.addEventListener('theme:desktop-sticky-change', queueSync);
  document.addEventListener('scroll', queueSync, { passive: true });
  window.addEventListener('resize', queueSync, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }
})();
